import React from 'react'

const TermsOfService = () => {
  return (
    <div>TermsOfService</div>
  )
}

export default TermsOfService